import * as types   from "../../constants/action-types";
import * as Routes  from 'constants/routes';
import { changeArrayKeys, dropDuplicates } from '../../app/functions';

let initialState = {
    autocompleteResults: [],
    autocompleteStatus: 'IDLE',
    ContactPage:false,
    ContentData:false,
    OurStory:false,
    BenefitPage:false,
    LastBenefitPage:false,
    HomepageData:false,
    HomepageSecondarySliders:false,
    AppDown:false,
    BenefitDown:false,
    VIPBenefitDown:false,
    LeadStatus:false,
    FilteredBenefits: false,
    Newsletter_subscribe:false,
    Newsletter_subscription_response_text: '',
    MetaTags: {},
    PinBenefits: false,
    policy_page_id: false,
    SuppliersJoinPage:false,
    ClientsJoinPage:false,
    UserAppStatus: false,
    SupplierAppStatus:false,
    vipBenefitErrMsg:'',
    WalletPage:false,
    MembershipPage:false,
    MembershipFormReturn:false,
    MembershipPageErr:'',
    Favorites: false,
    BenefitAcquired: false,
    BenefitAcquiredErr: false,
    BenefitPurchased: false,
    freeSearchData:false,
    freeSearchRecords:[],
    OtpResponse: false,
    TelecardUrl: false,
    AvailableCoupon: false,
    AvailableCouponErr: false,
    ExpertsPage: false,
    ExpertLead: false,
    PayCouponResult: false,
    StreetList: false,
    Coupon:false,
    UserOrders:false,
    UserDetailedOrders: {},
    Filters:false,
    VerificationStatus: false,
    OrderNotReceived: false,
    LandingPageData: false,
    MailLinkPage: false,
    OrderSmartWallet:"",
    onlyBenefits:false,
    onlyTrades: false,
    tutorial_display_number:0,
    VehicleAdsPage:false,
    VehicleAdsOnSuccess:[],
    benefitsArray:[],
    shouldShowTabs:false,
    searchBenefitsArray:[],
    leadFormReturn: false,
    magazineCrumbs: [],
    magazineCategories: [],
    homepageMagazineArticles: [],
    legalAdvicePage: false,
    legalAdviceQuestion: false,
    legalAdviceQuestions: false,
    legalAdviceQuestionResults: false,
    legalAdviceQuestionSubmit: false,
    allBenefits: false,
    categoryBenefits: false,
    homepageSearchQuery: '',
    appDynamicLink: false,
    isFirstRegistrationNeeded: false,
    loginCode: 0,
    userIdLogin: 0,

};

export default function data_reducer(state = initialState, action) {
    const responseData = action.payload;
    let newState = {};

    switch (action.type) {
        case types.SET_MAIL_LINK_PAGE:
            return{
                ...state,
                MailLinkPage: action.payload
            };
        case types.SET_DYNAMIC_LINK:
            return {
                ...state,
                appDynamicLink: responseData,
            };
        case types.SET_LANDING_PAGE_DATA:
            return{
                ...state,
                LandingPageData: action.payload,
            };
        case types.SET_ORDER_NOT_RECEIVED:
            return{
                ...state,
                OrderNotReceived: action.payload,
            };
        case types.SET_VERIFICATION:
            return{
                ...state,
                VerificationStatus: action.payload,
            };
        case types.SET_FILTERS: {
            return {
                ...state,
                Filters: action.payload
            };
        }
        case types.SET_IS_FIRST_REGISTRATION_NEEDED:
            return {
                ...state,
                isFirstRegistrationNeeded: action.payload,
            };

        case types.SET_USER_ID_LOGIN:
            return {
                ...state,
                userLoginId: action.payload,
            };
        case types.SET_USER_PHONE_LOGIN:
            return {
                ...state,
                userPhoneLogin: action.payload,
            };

        case types.SET_ONLY_BENEFITS: {
            let oldRecords;
            let newRecords;
            let newOnlyBenefits = action.payload;

            //concat new lazy loaded results
            if(action.payload.metaData?.search?.current_page !== '1') {
                oldRecords = JSON.parse(JSON.stringify(state.onlyBenefits.records));
                newRecords = JSON.parse(JSON.stringify(action.payload.records));
                newRecords = oldRecords.concat(newRecords);
                newOnlyBenefits = {...action.payload, records: newRecords};
            }

            return {
                ...state,
                onlyBenefits: newOnlyBenefits
            };
        }

        case types.SET_ONLY_TRADES: {

            let oldRecords;
            let newRecords;
            let newOnlyTrades = action.payload;

            //concat new lazy loaded results
            if(action.payload.metaData?.search?.current_page !== '1') {
                oldRecords = JSON.parse(JSON.stringify(state.onlyTrades.records));
                newRecords = JSON.parse(JSON.stringify(action.payload.records));
                newRecords = oldRecords.concat(newRecords);
                newOnlyTrades = {...action.payload, records: newRecords};
            }

            return {
                ...state,
                onlyTrades: newOnlyTrades
            };
        }

        case types.SET_HOMEPAGE_SEARCH_QUERY: {
            return {
                ...state, homepageSearchQuery: action.payload
            }
        }

        case types.SET_USER_DETAILED_ORDER:
            let new_state = {...state};
            new_state.UserDetailedOrders[action.payload.order_id] = action.payload;
            return new_state;

        case types.SET_USER_ORDERS:
            return{
                ...state,
                UserOrders: action.payload
            };
        case types.SET_COUPON:
            return{
                ...state,
                Coupon: action.payload
            };
        case types.SET_STREET_LIST:
            return{
                ...state,
                StreetList: action.payload
            };
        case types.SET_COUPON_PAY_RESULT:
            return{
                ...state,
                PayCouponResult: action.payload
            };
        case types.SET_AVAILABLE_COUPON_ERR:
            return{
                ...state,
                AvailableCouponErr: action.payload
            };
        case types.SET_BENEFIT_ACQUIRED_ERR:
            return{
                ...state,
                BenefitAcquiredErr: action.payload
            };
        case types.SET_BENEFIT_PURCHASED:
            return{
                ...state,
                BenefitPurchased: action.payload
            };
        case types.SET_AVAILABLE_COUPON:
            return{
                ...state,
                AvailableCoupon: action.payload
            };
        case types.SET_TELECARD_URL:
            return{
                ...state,
                TelecardUrl: action.payload
            };
        case types.OTP_RESPONSE:
            return{
                ...state,
                OtpResponse: action.payload
            };
        case types.SET_FREE_SEARCH_DATA:
            return{
                ...state,
                freeSearchData: action.payload
            };
        case types.SET_FREE_SEARCH_RECORDS:
            return{
                ...state,
                freeSearchRecords: state?.freeSearchRecords?.concat(action.payload)
            };
        case types.RESET_FREE_SEARCH_RECORDS:
            return{
                ...state,
                freeSearchRecords: action.payload
            };
        case types.SET_BENEFIT_ACQUIRED:
            return{
                ...state,
                BenefitAcquired: action.payload
            };
        case types.SET_FAVORITES_DATA:
            return{
                ...state,
                Favorites: action.payload
            };
        case types.SET_EXPERT_LEAD:
            return{
                ...state,
                ExpertLead: action.payload
            };
        case types.SET_EXPERTS_PAGE:
            return{
                ...state,
                ExpertsPage: action.payload
            };
        case types.SET_MEMBERSHIP_ERR:
            return{
                ...state,
                MembershipPageErr: action.payload
            };
        case types.SET_MEMBERSHIP_RETURN:
            return{
                ...state,
                MembershipFormReturn: action.payload,
            };
        case types.SET_MEMBERSHIP_PAGE:
            return{
                ...state,
                MembershipPage: action.payload
            };
        case types.SET_USER_APP:
            return{
                ...state,
                UserAppStatus: true
            };
        case types.SET_SUPP_APP:
            return{
                ...state,
                SupplierAppStatus: true
            };
        case types.SET_SUPPLIER_JOIN_PAGE: {
            return {
                ...state,
                SuppliersJoinPage: action.payload
            };
        }
        case types.SET_POLICY_PAGE_ID: {
            return {
                ...state,
                policy_page_id: action.payload
            };
        }
        case types.SET_FILTERED_BENEFITS: {
            return {
                ...state,
                FilteredBenefits: action.payload
            };
        }
        case types.SET_META_TAGS: {
            return {
                ...state,
                MetaTags: {...state.MetaTags, [action.payload.route] : action.payload.val}
            };
        }
        case types.SET_HOMEPAGE_DATA:
            return {
                ...state,
                HomepageData: action.payload,
                HomepageSecondarySliders: false,
            };
        case types.SET_HOMEPAGE_SECONDARY_SLIDERS:
            return {
                ...state,
                HomepageSecondarySliders: action.payload,
            };
        case types.SET_AUTOCOMPLETE_RESULTS:
            return {
                ...state,
                autocompleteResults: action.payload === false ? [] : action.payload,
                autocompleteStatus: action.payload === false ? 'IDLE' : state.autocompleteStatus,
            };
        case types.SET_AUTOCOMPLETE_STATUS:
            return {
                ...state,
                autocompleteStatus: action.payload,
            };
        case types.SET_CONTACT_PAGE:
            return{
                ...state,
                ContactPage:action.payload,
            };
        case types.SET_CONTENT_DATA:
            return{
                ...state,
                ContentData: action.payload
            };
        case types.SET_ORDER_SMART_WALLET:
            return{
                ...state,
                OrderSmartWallet: action.payload
            };
        case types.SET_OUR_STORY:
            return{
                ...state,
                OurStory: action.payload
            };
        case types.SET_BENEFIT_PAGE:
            return{
                ...state,
                BenefitPage: action.payload,
                LastBenefitPage: action.payload || state.LastBenefitPage,
            };
        case types.SET_APP_DOWN_STATUS:
            return{
                ...state,
                AppDown: action.payload,

            };
        case types.SET_LEAD_STATUS:
            return{
                ...state,
                LeadStatus: action.payload
            };
        case types.SET_NEWSLETTER_STATUS:
            return{
                ...state,
                Newsletter_subscribe: action.payload
            };
        case types.SET_NEWSLETTER_SUBSCRIPTION_RESULT_TEXT:
            return{
                ...state,
                Newsletter_subscription_result_text: action.payload
            };
        case types.ADD_FILTERED_BENEFITS: {
            return {
                ...state,
                FilteredBenefits: {
                    ...state.FilteredBenefits,
                    records: [...state.FilteredBenefits.records].concat(action.payload)}
            };
        }
        case types.SET_PIN_BENEFITS:
            return{
                ...state,
                PinBenefits: action.payload
            };
        case types.RESET_PIN_BENEFITS:
            return{
                ...state,
                PinBenefits: false
            };
        case types.SET_CLIENT_JOIN_PAGE:
            return{
                ...state,
                ClientsJoinPage: action.payload
            };
        case types.RESET_BENEFIT_STATUS:
            return{
                ...state,
                BenefitDown: false,
            };
        case types.SET_BENEFIT_STATUS:
            return{
                ...state,
                BenefitDown: action.payload
            };
        case types.SET_VIP_BENEFIT_STATUS:
            return{
                ...state,
                VIPBenefitDown: action.payload
            };
        case types.VIP_MESSAGE:
            return{
                ...state,
                vipBenefitErrMsg: action.payload
            };
        case types.SET_WALLET_PAGE:
            return{
                ...state,
                WalletPage: action.payload
            };
        case types.SET_VEHICLE_ADS_PAGE:
            return{
                ...state,
                VehicleAdsPage: action.payload
            };
        case types.SET_LOGIN_CODE:
            return{
                ...state,
                loginCode: action.payload
            };
        case types.SET_LOGIN_ID:
            return{
                ...state,
                userLoginId: action.payload
            };
        case types.SET_BENEFITS_ARRAY:
            let oldRecords;
            let newRecords;
            let newBenefits = action.payload;
            let benefitsStatus= action.payload.benefitsStatus

            //concat new lazy loaded results
            if(action.payload[benefitsStatus].metaData.search?.current_page !== '1') {
                oldRecords = JSON.parse(JSON.stringify(state.benefitsArray[benefitsStatus].records));
                newRecords = JSON.parse(JSON.stringify(action.payload[benefitsStatus].records));
                newRecords = oldRecords.concat(newRecords);
                let payLoadCopy= {...action.payload}
                payLoadCopy[`${benefitsStatus}`].records=newRecords
                newBenefits = payLoadCopy;
            }
            return{
                ...state,
                benefitsArray: newBenefits
            };

            case types.SET_SEARCH_BENEFITS_ARRAY:
                let oldRec;
                let newRec;
                let newBen = action.payload;
                let benefitsStat= action.payload.benefitsStatus
                let currPage= action.payload[benefitsStat].metaData.search?.current_page
            //concat new lazy loaded results
            if(currPage !== '1' && currPage !== 1) {
                oldRec = JSON.parse(JSON.stringify(state.searchBenefitsArray[benefitsStat].records));
                newRec = JSON.parse(JSON.stringify(action.payload[benefitsStat].records));
                newRec = oldRec?.concat(newRec);
                let payLoadCopy= {...action.payload}
                payLoadCopy[`${benefitsStat}`].records=newRec
                newBen = payLoadCopy;
            }
            return{
                ...state,
                searchBenefitsArray: newBen
            };


        case types.SET_SHOULD_SHOW_TABS:
            return{
                ...state,
                shouldShowTabs: action.payload
            };
        case types.SET_VEHICLE_ADS_ON_SUCCESS:
            const newArray = [...state.VehicleAdsOnSuccess];
            newArray.push(parseInt(action.payload));
            return{
                ...state,
                VehicleAdsOnSuccess: newArray,
            };
            case types.SET_TUTORIAL_DISPLAY_NUMBER:
                return{
                ...state,
                tutorial_display_number: action.payload
            };
        case types.SET_LEAD_FORM_VALID:
            return{
                ...state,
                leadFormReturn: action.payload
            };
        case types.ADD_MAGAZINE_CRUMB:
            let newCrumbs = [...state.magazineCrumbs];
            let res = newCrumbs.filter((item) => item.route === action.payload.route)
            if(res.length > 0){
                newCrumbs = newCrumbs.filter(item => item.route !== action.payload.route);
            } else {
                newCrumbs = [...newCrumbs, action.payload];
            }
            return {...state, magazineCrumbs: newCrumbs}
        case types.SET_MAGAZINE_CATEGORIES:
            return { ...state, magazineCategories: action.payload };
        case types.SET_HOMEPAGE_MAGAZINE_ARTICLES:
            return { ...state, homepageMagazineArticles: action.payload };
        case types.SET_LEGAL_ADVICE_PAGE:
            return {
                ...state,
                legalAdvicePage: {
                    ...action.payload,
                    categories: changeArrayKeys(action.payload.categories),
                    tags: action.payload.tags,
                },
            };
        case types.SET_LEGAL_ADVICE_QUESTION:
            return {
                ...state,
                legalAdviceQuestion: action.payload,
            };
        case types.RESET_LEGAL_ADVICE_QUESTION:
            return {
                ...state,
                legalAdviceQuestion: false,
            };
        case types.SET_LEGAL_ADVICE_QUESTIONS:
            return {
                ...state,
                legalAdviceQuestions: action.payload,
            };
        case types.SET_LEGAL_ADVICE_QUESTION_RESULTS:
            return {
                ...state,
                legalAdviceQuestionResults: action.payload,
            };
        case types.RESET_LEGAL_ADVICE_QUESTION_RESULTS:
            return {
                ...state,
                legalAdviceQuestionResults: false,
            };
        case types.SET_LEGAL_ADVICE_QUESTION_SUBMIT:
            return {
                ...state,
                legalAdviceQuestionSubmit: action.payload,
            };
        case types.RESET_LEGAL_ADVICE_QUESTION_SUBMIT:
            return {
                ...state,
                legalAdviceQuestionSubmit: false,
            };
        case types.SET_ALL_BENEFITS:
            const existingAllBenefits = state.allBenefits;

            if (!existingAllBenefits) {
                newState = responseData;
            } else {
                newState = {
                    ...existingAllBenefits,
                    metaData: responseData.metaData,
                    records: responseData.metaData.currentPage === 1
                        ? responseData.records
                        : dropDuplicates([...existingAllBenefits.records, ...responseData.records]),
                };
            }

            return {
                ...state,
                allBenefits: newState,
            };
        case types.SET_CATEGORY_BENEFITS:
            const existingCategoryBenefits = state.categoryBenefits;

            if (!existingCategoryBenefits) {
                newState = responseData;
            } else {
                newState = {
                    ...existingCategoryBenefits,
                    metaData: responseData.metaData,
                    records: responseData.metaData.currentPage === 1
                        ? responseData.records
                        : dropDuplicates([...existingCategoryBenefits.records, ...responseData.records]),
                };
            }

            return {
                ...state,
                categoryBenefits: newState,
            };
        default:
            return state;
    }
}
